export const nodata = 'N/D'